import { SecondaryButton, PrimaryButton } from "Element/Button";
import Container from "Element/Container";
import { Flex } from "Element/Flex";
import { dogeImgList } from "../dogeList";
import {
  StyledLanding,
  BackgroundWrapper,
  StyledHeroText,
  DogeImgContainer,
  DogeImgWrapper,
  DogeImg,
  GoDownButton,
} from "../styled";
import {
  HeroTextWrapper,
  HeroTextShadow,
  ButtonWrapper,
  HeroWrapper,
} from "./styled";
import { ReactComponent as ArrowDown } from "assets/icons/arrow-down.svg";
import { useDispatch } from "react-redux";
import { handleModalOpen } from "state/modalSlice";

const LandingContent = () => {
  const dispatch = useDispatch();
  return (
    <Container>
      <StyledLanding>
        <BackgroundWrapper>
          <HeroWrapper>
            <HeroTextWrapper>
              <StyledHeroText>adopt your doge right now!</StyledHeroText>
              <HeroTextShadow>adopt your doge right now!</HeroTextShadow>
            </HeroTextWrapper>
            <ButtonWrapper justifyContent="center">
              <a
                href="https://discord.com/invite/boxy"
                target="_blank"
                rel="noreferrer"
              >
                <SecondaryButton>Join Discord</SecondaryButton>
              </a>
              <PrimaryButton onClick={() => dispatch(handleModalOpen())}>
                Mint Your NFT
              </PrimaryButton>
            </ButtonWrapper>
          </HeroWrapper>
          <DogeImgContainer
            alignItems="flex-end"
            justifyContent="center"
            flexWrap="nowrap"
          >
            {dogeImgList.map((doge) => (
              <DogeImgWrapper key={dogeImgList.indexOf(doge)}>
                <DogeImg src={doge} />
              </DogeImgWrapper>
            ))}
          </DogeImgContainer>
        </BackgroundWrapper>
      </StyledLanding>
      <Flex mb={20} alignItems="center" justifyContent="center">
        <GoDownButton small>
          <ArrowDown />
        </GoDownButton>
        <GoDownButton>
          <ArrowDown />
        </GoDownButton>
        <GoDownButton small>
          <ArrowDown />
        </GoDownButton>
      </Flex>
    </Container>
  );
};

export default LandingContent;
